import { useAuthorization } from '../../../../contexts/AuthorizationContext';
import { useEffect, useRef } from 'react'
import { useDidMountEffect } from '../../../../utils/utils';
import { Grid, Avatar, Button, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Step, StepLabel, StepContent, Box, Typography, List, ListItem, ListItemText, Stack } from '@mui/material';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import QuillCursors from 'quill-cursors';
import styled from "styled-components";
// import { StartSocket } from '../../../../services/SocketService';
import { useState } from 'react';
import IconLabelButtons from './../../../../components/ButtonIconSalvar';
import { usePallet } from './../../../../contexts/PalletContext';
import { useAlert } from "../../../../contexts/AlertContext";
import { setTextRange } from 'typescript';
import $ from "jquery";
import ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService from "../../../../services/ProposicaoAcaoPreparatoriaNotaTecnicaColaborativaService";
import { Height, SettingsPhoneOutlined } from '@material-ui/icons';
import InputMultilineTextField from '../../../../components/InputMultilineTextField';
import ClearIcon from '@mui/icons-material/Clear';
import NTColaborativaImprimir from './NTColaborativaImprimir';
import { htmlToText } from 'html-to-text';
import StringsFile from 'strings-file';
import { saveAs } from "file-saver";
import CircularLoading from '../../../../components/CircularLoading';
import { isMobile } from 'react-device-detect';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
// import HTMLtoDOCX from 'html-to-docx';
import html2pdf from 'html2pdf.js';
import { asBlob } from 'html-docx-js-typescript';
import ConversaModal from './NotaTecnicaColabChatIA';
import ProposicaoService from '../../../../services/ProposicaoService';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import EmptyError from '../../../../components/EmptyError';
import moment from 'moment';
import AnexosComponent, { EAnexoModulos } from '../../../../components/Anexos';
import AnexosComponentColab from '../../../../components/AnexosColab';
import clsx from "clsx";
import useStyles from '../../../../components/layout/Styles';


function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

export interface IRange {
    index: number,
    length: number
}
interface IActiveUser {
    acesso: string;
    cliente: {
        id: number;
        nome: string;
    }
    departamento: string;
    id: Number;
    nome: string;
    url_foto: string;
    color?: string;
    range?: {
        index: number;
        length: number;
    };
}

interface HistoricoItem {
    texto: string;
    criado_em: string;
    id_usuario: number;
    nome_usuario: string;
}

const UsersPanel = styled(Grid)`
  min-height: 55px;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
    overflow-x: auto;
  .ButtonGrid {
    margin-left: auto;
      display: flex;
     flex-wrap: nowrap;
       overflow-x: auto;
    button {
      height: 55px;
      margin: 10px;
    }
  }
`;

const ActiveUser = styled(Grid)`
  .userAvatar {
    cursor: pointer;
    margin-top: 6px;
    margin-left: 10px;

    & + .userAvatar {
      margin-left: 5px;
    }
  }

  &::after  {
    content: "";
      height: 3px;
      border-radius: 3px 3px 0 0;
      width: 40px;
      position: absolute;
      bottom: 5px;
      margin-left: 10px;
      /* left: 0; */
      background: ${(props => props.color ? props.color : "unset")}
  }
`;

const Editor = styled(Grid)`
  .ql-container, .ql-editor {
    height: ${props => props.pageHeight - 257}px;
  }
  .ql-container {
    background-color: #E1E8F2;
  }
  .ql-editor {
    background-color: #fff;
    margin: 35px 10%;
    padding: 30px;
  }
  .ql-comments-add {
    display: flex !important;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    
    /* largura mínima para não encolher demais */
    min-width: 100px;
    /* altura fixa ou mínima */
    height: 40px;
    min-height: 40px;
    
    font-size: 15px;
    background: grey !important;
    border-radius: 3px;
    margin-top: 18px;
    color: white !important;
    
    /* padding horizontal apenas */
    padding: 0 10px !important;
    }

    .ql-comments-add::after {
    content: "Comentar";
    }
    .ql-text-ia-add {
    display: flex !important;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    
    /* largura mínima para não encolher demais */
    min-width: 100px;
    /* altura fixa ou mínima */
    height: 40px;
    min-height: 40px;
    
    font-size: 15px;
    background: grey !important;
    border-radius: 3px;
    margin-top: 18px;
    color: white !important;
    
    /* padding horizontal apenas */
    padding: 0 10px !important;
    }

    .ql-text-ia-add::after {
    content: "IA Assistente";
}
  .ql-print {
    width: 100% !important;
    
    &:after {
      content: "imprimir";
    }
  }
  .ql-cursors {
    .ql-cursor-caret-container {
      margin-left: -15px;
      padding: 0;
    }
    .ql-cursor-flag { 
      display: flex;
      justify-content: center;
      z-index: 100;

      small {
        margin: 0 5px;
      }
    }
  }
`;

function htmlParaTextoSimples(html?: string) {
    if (!html) return ''
    return html
        .replace(/<\s*p[^>]*>/gi, '')
        .replace(/<\s*\/\s*p>/gi, '\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .trim()
}

const RealTimeQuillEditor = (
    props: {
        docId: number,
        modules,
        value: string,
        onSave,
        onChange,
        onComment?,
        idNotaTecnica: number,
        id_proposicao?: number,
        onEdit?,
    }
) => {
    const { pallet } = usePallet();
    const { NewAlert } = useAlert();
    const classes = useStyles();

    const quillRef = useRef(null);
    const [editor, setEditor] = useState(quillRef.current && quillRef.current.getEditor());
    const { user } = useAuthorization();




    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [openChatIA, setOpenChatIA] = useState(false);
    const [selectionTextRange, setSelectionTextRange] = useState<IRange>({ index: 0, length: 0 });
    const [quote, setQuote] = useState<string>("");
    const [commentary, setCommentary] = useState<string>("");
    const [lawText, setLawText] = useState<any>("");
    const [summaryText, setSummaryText] = useState<any>("");
    const [tab, setTab] = useState('1');
    const [selectedIdx, setSelectedIdx] = useState<number | null>(null)
    const [listItemSelected, setListItemSelected] = useState<number>(-1)
    const [arrayCommentsState, setArrayCommentsState] = useState([]);
    const [idNotaColab, setIdNotaColab] = useState<number>();
    const [subcomentario, setSubcomentario] = useState('');
    const [subcomentarioList, setSubcomentarioList] = useState([]);
    const [indexSubComments, setIndexSubComments] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingAnexo, setloadingAnexo] = useState(false);
    const [minComments, setMinComments] = useState(false);
    const [pageHeight, setPageHeight] = useState(window.innerHeight);
    const [resGetUserNameEditing, setResGetUserNameEditing] = useState('');
    const [resGetUserIdEditing, setResGetUserIdEditing] = useState(0);
    const [historico, setHistorico] = useState<HistoricoItem[]>([]);
    const [currentText, setCurrentText] = useState('');
    const [selected, setSelected] = useState<HistoricoItem | null>(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        ProposicaoService.getHistorico(props.idNotaTecnica)
            .then(data => {
                setHistorico(data)
                if (data.length > 0) {
                    setListItemSelected(data.length - 1)
                    setCurrentText(data.at(-1).texto)
                }
            })
            .catch(() => setHistorico([]))
    }, [props.idNotaTecnica])

    const handleClickItem = (item: HistoricoItem, idx: number) => {
        setSelected(item)
        setSelectedIdx(idx)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleResgatar = () => {
        if (selectedIdx !== null) {
            setListItemSelected(selectedIdx)
            setCurrentText(selected?.texto ?? '')
        }
        setOpen(false)
    }

    // const handleEdit = () => {
    //     if (selected) {
    //         setEditorContent(selected.texto);
    //         handleClose();
    //     }
    // };

    useEffect(() => {
        getUserEdition();

        const updatePageHeight = () => {
            setPageHeight(window.innerHeight);
        };

        window.addEventListener('resize', updatePageHeight);

        return () => {
            window.removeEventListener('resize', updatePageHeight);
        };
    }, []);

    // useEffect(() => {
    //     if (props.value !== undefined && props.value !== socketData) {
    //         setSocketData(props.value)
    //     }
    // }, [props.value])

    useEffect(() => {
        const idNum = Number(props.id_proposicao);
        if (!Number.isInteger(idNum) || idNum <= 0) {
            return;
        }
        ProposicaoService
            .GetTextoProposicao(idNum)
            .then(res => {
                if (res) {
                    const textoTratado = clearText(res.texto)
                    if (textoTratado) {
                        setLawText(textoTratado);
                        setSummaryText(res.sumario)
                    }
                }
            })
            .catch(err => console.error(err));
    }, [props.id_proposicao]);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };





    const clearText = (transcricao) => {
        try {
            return transcricao
                .replace(/\s+/g, ' ') // Remove espaços em branco extras 
                .replace('CÂMARA DOS DEPUTADOS ', '')
                .replace('C ÂMARA DOS D EPUTADOS ', '')
                .replace('C Â M A R A D O S D E P U T A D O S', '')
                .replace('Gabinete do Deputado Federal', '')
                .replace('____/_____/_____', '')
                // 1) Normalizações gerais
                .replace(/\s+/g, ' ')                   // remove espaços em branco excessivos
                .replace(/^\s+|\s+$/g, '')              // trim

                // 2) Cabeçalhos institucionais e seções fixas
                .replace(/CONGRESSO NACIONAL\s*/gi, '')
                .replace(/SENADO FEDERAL\s*/gi, '')
                .replace(/REP(?:Ú|U)BLICA FEDERATIVA DO BRASIL\s*•\s*IMPRENSA NACIONAL\s*/gi, '')
                .replace(/ANO [IVXLCDM]+ Nº [\w-]+/gi, '')
                .replace(/ISSN \d{4}-\d{4}\s*/gi, '')

                // 3) Atos e mensagens (Veto, Medida Provisória, Mensagem)
                .replace(/VETO N[°º] \d+,\s*DE \d{4}\s*/gi, '')
                .replace(/MEDIDA PROVISÓRIA Nº \d+,\s*DE \d{4}\s*/gi, '')
                .replace(/MENSAGEM Nº \d+(\s+de\s+\d{4})?/gi, '')

                // 4) Datas de publicação (DOU/DCN), locais e assinaturas digitais
                .replace(/DOU de \d{2}\/\d{2}\/\d{4}\s*/gi, '')
                .replace(/DCN de \d{2}\/\d{2}\/\d{4}\s*/gi, '')
                .replace(/Brasília\s*[-–—]\s*[^\d]+\d{4}\s*/gi, '')
                .replace(/Documento assinado digitalmente[\s\S]*?código \d+\s*/gi, '')

                // 5) Listas de documentos e notas de rodapé
                .replace(/DOCUMENTOS:\s*[\s\S]*?(?=PUBLICAÇÃO:)/gi, '')
                .replace(/Avulso do (?:VET|RQS) \d+\/\d+\s*/gi, '')
                .replace(/Avulso Contém os Seguintes Documentos:[\s\S]*?(?=–|$)/gi, '')
                .replace(/–\s*(?:Autógrafo|Medida provisória original|Mensagem do Presidente|Exposição de Motivos|Ofício nº)[\s\S]*?(?=–|$)/gi, '')

                // 6) Linhas de paginação e numeração solta
                .replace(/\[\d+ de \d+\]\s*/g, '')        // [1 de 5]
                .replace(/^\d+\s*/gm, '')                // linhas que só tenham números

                // 7) Outras remoções pontuais vistas nos exemplos
                .replace(/Gabinete do Senador.*?(?=[A-Z])/gi, '')
                .replace(/Página da matéria\s*/gi, '')
                .replace(/SF\/\d+\.\d+-\d+ \(LexEdit\)\s*/gi, '')

                .trim(); // Remove espaços no inicio e no fim
        } catch (error) {
            console.error("Houve um erro ao limpar o texto.", error.message);
            return transcricao;
        };
    };



    Quill.register('modules/cursors', QuillCursors);
    const newModules = {
        cursors: {
            transformOnTextChange: true,
        },
        ...props.modules
    }


    useEffect(() => {
        getComments();
        SubConsulting();

        if (editor) {
            if (props.onComment) {
                const addCommentBtn = document.querySelector('button.ql-comments-add');
                if (addCommentBtn) {
                    addCommentBtn.addEventListener('click', () => {
                        const range = editor.getSelection();
                        if (!range || range.length === 0) {
                            NewAlert("error", "Selecione um trecho antes de comentar.");
                            return;
                        }
                        commentAddClick(range);
                    });
                }
            }

            // Botão Texto IA - protegido contra null
            const addTextIABtn = document.querySelector('button.ql-text-ia-add');
            if (addTextIABtn) {
                addTextIABtn.addEventListener('click', () => {
                    handleOpenChatIAModal();
                });
            }
        }
    }, [editor]);



    useEffect(() => {
        setEditor(quillRef.current.getEditor())
    }, [quillRef])


    useEffect(() => {
        getComments()
    }, [idNotaColab])

    const handleOpenChatIAModal = () => {
        setOpenChatIA(true);
    };

    const handleCloseChatIAModal = () => {
        setOpenChatIA(false);
    };

    const commentAddClick = (range: IRange) => {
        const text = editor.getText(range.index, range.length)
        setSelectionTextRange(range)
        setQuote(text)
        setModalOpen(true)
    }

    const saveComment = () => {
        editor.formatText(selectionTextRange.index, selectionTextRange.length, {
            background: "#ffe87f",
        });

        let data = {
            nomeComentario: commentary,
            textoGrifado: quote,
            nomeComentarista: user.nome,
            idComentarista: user.id,
        }

        ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.PostComments(props.idNotaTecnica, data).then((res) => {
            setIdNotaColab(res)
            if (res) {
                NewAlert("success", "Nota Colaborativa cadastrada com sucesso")
            } else {
                NewAlert("error", "Erro ao cadastrar, selecione o trecho e salve novamente");
            }
        })


        setModalOpen(false)
        setQuote("")
        setCommentary("")
        setSelectionTextRange({ index: 0, length: 0 })
        // setSocketData(editor.root.innerHTML)
        getComments()
    }

    const getComments = async () => {
        if (props.idNotaTecnica && props.idNotaTecnica !== undefined) {
            setLoading(true)
            await ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.GetComments(props.idNotaTecnica).then((res) => {
                setArrayCommentsState(res)
                setTimeout(() => {
                    setLoading(false)
                }, 500);
            }).then();
        }
    }

    const getUserEdition = async () => {
        await ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.GetUserEditing(props.idNotaTecnica).then((res) => {
            if (res) {
                setResGetUserIdEditing(res.id_user_editing);
                setResGetUserNameEditing(res.name_user_editing);
            }
        }).then();
    }

    const handleSubComentarioChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        setSubcomentario(event.target.value)
        setIndexSubComments(index)
    };

    const saveSubComment = (idNotaColab) => {
        if (subcomentario !== '') {
            let data = {
                subcomentario: subcomentario,
                nomeComentarista: user.nome,
                idComentarista: user.id,
            }
            ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.PostSubComments(idNotaColab, data).then((res) => {
                if (res > 0) {
                    NewAlert("success", "Sub-comentário cadastrado com sucesso")
                    setTimeout(() => {
                        setSubcomentario('')
                    }, 500);
                } else {
                    NewAlert("error", "Erro ao cadastrar, escreva novamente e salve");
                }
            })
                .then(() => SubConsulting());
        } else {
            NewAlert("error", "Observação vazia, escreva e tente novamente");
        }
    }


    const excluirComment = async (idNotaColab) => {
        if (idNotaColab) {
            await ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.DeleteComments(idNotaColab).then((res) => {
                if (res) {
                    NewAlert("success", "Comentário foi excluido com sucesso")
                    setTimeout(() => {
                    }, 500);
                } else {
                    NewAlert("error", "Erro ao excluir, por favor tente novamente");
                }
            });

            setModalOpen(false)
            setQuote("")
            setCommentary("")
            setSelectionTextRange({ index: 0, length: 0 })
            getComments();
        }
    }

    const SubConsulting = async () => {
        await ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.GetSubComments().then(resSub => {
            setSubcomentarioList(resSub)
        })
    }

    const keyUpActiveDoc = (event: React.KeyboardEvent<HTMLDivElement>): boolean => {
        const editorDiv = event.target as HTMLDivElement;
        const text = editorDiv.innerHTML;
        setCurrentText(text)
        return true;
    }

    const deleteSubComment = (id) => {
        ProposicaoAcaoInfluenciaNotaTecnicaColaborativaService.DeleteSubComment(id).then((res) => {
            if (res) {
                NewAlert("success", "Sub-comentário apagado com sucesso")
            } else {
                NewAlert("error", "Erro ao apagar, tente novamente");
            }
        }).then(() => SubConsulting());
    }

    const imprimir = () => {
        // window.print();

        const htmlContent = editor.root.innerHTML;
        const element = document.createElement('div');
        element.innerHTML = htmlContent;
        html2pdf().from(element).set({ margin: 10, filename: 'nota_colaborativa.pdf' }).save();
    }

    // const exportToDocx = async () => {
    //     const fileBuffer = await asBlob(editor.root.innerHTML, null)
    //     saveAs(fileBuffer, 'nota_colaborativa.docx');
    // }

    const exportToDocx = async () => {
        const htmlContent = editor.root.innerHTML;
        const fullHtml = `
            <!DOCTYPE html>
            <html lang="pt-BR">
            <head>
                <meta charset="UTF-8">
                <title>Nota Colaborativa</title>
            </head>
            <body>
                ${htmlContent}
            </body>
            </html>
        `;

        const fileBuffer = await asBlob(fullHtml, {
            orientation: 'portrait',
            margins: { top: 720, bottom: 720, left: 720, right: 720 },
        });

        saveAs(fileBuffer, 'nota_colaborativa.docx');
    };

    const expandingComments = () => {
        setMinComments(false)
    }

    const minimizeComments = () => {
        setMinComments(true)
    }

    const css = `
        @media print {
            body {
                visibility: hidden;
            }
            div.ql-editor {
                visibility: visible;
                position: absolute;
                left: 0;
                top: 0;
            }
        }
        `;

    const changeUserEditor = async (docId) => {
        try {
            const returnedId = await props.onEdit(docId);
        } catch (err) {
            console.error('Erro ao editar:', err);
            throw err;
        }
    };

    function htmlParaTextoSimples(html: string | undefined): string {
        if (!html) return '';
        return html
            .replace(/<\s*p[^>]*>/gi, '')                         // remove <p>
            .replace(/<\s*\/\s*p>/gi, '\n')                       // fecha <p> vira nova linha
            .replace(/<br\s*\/?>/gi, '\n')                        // br vira nova linha
            .replace(/<[^>]+>/g, '')                              // remove qualquer outra tag
            .trim();
    }


    function handleAfterUpload() {
                // setloadingAnexo(true)
            
             props.onSave(props.docId, editor.root.innerHTML)
            NewAlert('success', 'Documento salvo criado com sucesso')
        // setloadingAnexo(false)
    }

    return (
        <div>
            <style>{css}</style>
            <Editor pageHeight={pageHeight}>
                <UsersPanel>
                    <Grid style={{
                        fontFamily: pallet.general.fontFamily,
                        fontSize: '20px',
                        padding: '5px',
                        maxWidth: '40%'
                    }}>
                        {resGetUserNameEditing
                            ?
                            <>
                                Nota em edição por <span style={{
                                    fontWeight: pallet.general.weight_600,
                                }}>
                                    {resGetUserNameEditing}
                                </span>
                            </>
                            :
                            null

                        }
                    </Grid>
                    <Grid className='ButtonGrid'>
                        <Grid container >
                            <IconLabelButtons
                                key={"editar"}
                                onClick={() => changeUserEditor(props.docId)}
                                tipo={"editar"}
                                backgroundColor={pallet.backGroundPageColorSecondary}
                                border={!resGetUserIdEditing || user.id === resGetUserIdEditing ? 'light-grey' : "1px solid grey"}
                                fontColor={!resGetUserIdEditing || user.id === resGetUserIdEditing ? 'light-grey' : 'Black'}
                                fontSize={pallet.general.size12}
                                padding="0 20px"
                                icon={""}
                                // onBlock={editor?.root?.innerText?.length}
                                title={"PEDIR EDIÇÃO"}
                                disable={!resGetUserIdEditing || user.id === resGetUserIdEditing
                                    ?
                                    true
                                    :
                                    false
                                }
                            />
                            <IconLabelButtons
                                key={"salvar"}
                                onClick={() => props.onSave(props.docId, editor.root.innerHTML)}
                                tipo={"salvar"}
                                backgroundColor={pallet.backgroundColorPrimary}
                                border={"1px solid lightgrey"}
                                fontColor={pallet.textColorPrimary}
                                fontSize={pallet.general.size12}
                                padding="0 10px"
                                icon={""}
                                // onBlock={editor?.root?.innerText?.length}
                                title={"SALVAR TEXTO"}
                            />
                            <IconLabelButtons
                                key={"imprimir"}
                                onClick={() => imprimir()}
                                tipo={"imprimir"}
                                backgroundColor={pallet.backgroundColorQuaternary}
                                border={"1px solid white"}
                                fontColor={pallet.backgroundColorPrimary}
                                fontSize={pallet.general.size12}
                                padding="0 10px"
                                icon={""}
                                title={"PDF"}
                            />
                            <IconLabelButtons
                                key={"imprimirDocx"}
                                onClick={() => exportToDocx()}
                                tipo={"imprimirDocx"}
                                backgroundColor={pallet.backgroundColorQuaternary}
                                border={"1px solid white"}
                                fontColor={pallet.backgroundColorPrimary}
                                fontSize={pallet.general.size12}
                                padding="0 10px"
                                icon={""}
                                title={"DOCX"}
                            />

                            <Grid style={{padding:"0 20px"}}>
                            
                            <AnexosComponentColab
                                label={''}
                                id_referencia={props.docId}
                                modulo={EAnexoModulos.NotaTecnicaColab}
                                canEdit={true}
                                autosave={true}
                                 onAfterUpload={handleAfterUpload}

                            />
                            </Grid>

                            {minComments
                                ?
                                <Grid style={{
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                    marginTop: "30px",
                                    marginRight: "30px",
                                    marginLeft: "10px",
                                    fontFamily: `${pallet.general.fontFamily}`,

                                }}
                                    onClick={() => expandingComments()}>
                                    Ver Comentários
                                </Grid>
                                :
                                null
                            }


          
                        </Grid>
                    </Grid>


                </UsersPanel>



                <Grid container>
                    <Grid>
                        <ReactQuill
                            modules={newModules}
                            ref={quillRef}
                            style={{ minHeight: 700, maxWidth: minComments ? "100%" : 750 }}
                            value={currentText}
                            onKeyUp={keyUpActiveDoc}
                            theme="snow"
                            preserveWhitespace={true}
                            readOnly={!resGetUserIdEditing || user.id === resGetUserIdEditing ? false : true}
                        />
                    </Grid>
                    {minComments
                        ?
                        null
                        :
                        <Grid style={{
                            fontFamily: `${pallet.general.fontFamily}`,
                            padding: '10px',
                            marginBottom: '50px',
                            backgroundColor: `#F2F0EF`,
                            maxWidth: '370px',
                            marginLeft: '15px',
                            width: '100%'
                        }}>
                            <Box sx={{ width: '100%', typography: 'body1' }}>
                                <TabContext value={tab}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleChangeTabs} aria-label="tab"
                                            TabIndicatorProps={{
                                                style: {
                                                    backgroundColor: pallet.general.color1,
                                                }
                                            }}>
                                            <Tab label="Anexos" value="1" style={{ color: pallet.general.color1 }} />
                                            <Tab label="Comentários" value="2" style={{ color: pallet.general.color1 }} />
                                            <Tab label="Histórico" value="3" style={{ color: pallet.general.color1 }} />
                                        </TabList>
                                    </Box>

                                    <TabPanel value="1">


                                     <Grid  style={{
                                            width: "500px",
                                          
                                            // marginTop: '20px'
                                        }}>
                                            <AnexosComponentColab
                                                label={""}
                                                modulo={EAnexoModulos.NotaTecnicaColab}
                                                id_referencia={props.docId}
                                                canEdit={false}
                                                autosave={true}
                                            />
                                    </Grid>
                                    
                                    </TabPanel>

                                    <TabPanel value="2" >
                                        <Grid style={{
                                            maxHeight: `${pageHeight - 247}px`,
                                            overflow: 'auto',
                                            // marginTop: '20px'
                                        }}>

                                            {loading ?
                                                <CircularLoading
                                                    positionCustom={true}
                                                    size={60}
                                                    top={isMobile ? "37%" : "50%"}
                                                    left={isMobile ? "6%" : "45%"}
                                                    zIndex={2}
                                                />
                                                :
                                                arrayCommentsState.length === 0
                                                    ?
                                                    <Grid style={{ width: '100%' }}>
                                                        <EmptyError title="Ops!" description="Ainda não temos comentários." origin='quill' />

                                                    </Grid>
                                                    :
                                                    arrayCommentsState?.map((x, index) => {
                                                        return (
                                                            <Grid key={index} style={{ wordBreak: 'break-all' }}>
                                                                <div style={{ cursor: "pointer" }}>
                                                                    <div style={{ fontSize: '13px', fontWeight: 800, fontStyle: 'italic' }}>
                                                                        ...{x.texto_grifado}...
                                                                    </div>
                                                                    <div style={{ fontSize: '10px' }}>
                                                                        <span style={{ fontWeight: 600 }}>Comentário:</span> {x.titulo}
                                                                    </div>
                                                                    <div style={{ fontSize: '10px' }}>
                                                                        Autor: {x.nome_user}
                                                                    </div>
                                                                </div>
                                                                <Grid style={{
                                                                    borderLeft: '3px solid grey'
                                                                }}>
                                                                    {subcomentarioList?.filter(op => op.id_comment === x.id).map(el => {
                                                                        return (
                                                                            <Grid container justifyContent={'space-between'}>
                                                                                <Grid xl={11} lg={11}>
                                                                                    <div style={{
                                                                                        fontSize: "11px",
                                                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                                                        fontWeight: pallet.general.weight_bold,
                                                                                        marginTop: '8px',
                                                                                        paddingLeft: '10px'
                                                                                    }}>
                                                                                        {el.observacao}
                                                                                    </div>
                                                                                    <div style={{
                                                                                        fontSize: '10px',
                                                                                        paddingLeft: '10px'
                                                                                    }}>
                                                                                        Autor: {el.nome_user}
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid style={{ cursor: 'pointer' }} xl={1} lg={1} onClick={() => deleteSubComment(el.id)}>
                                                                                    <ClearIcon style={{
                                                                                        fontSize: '12px',
                                                                                        marginRight: '5px'
                                                                                    }} />
                                                                                </Grid>
                                                                            </Grid>
                                                                        )
                                                                    })}
                                                                </Grid>

                                                                <Grid lg={12} xs={12} style={{
                                                                    marginTop: '12px',
                                                                    paddingRight: '9px'
                                                                }}>
                                                                    <input
                                                                        style={{
                                                                            fontFamily: `${pallet.general.fontFamily}`,
                                                                            width: '100%',
                                                                            fontSize: '12px',
                                                                            padding: '3px'
                                                                        }}
                                                                        type="text"
                                                                        name={String(index)}
                                                                        value={index === indexSubComments ? subcomentario : null}
                                                                        onChange={(e) => handleSubComentarioChange(e, index)}
                                                                    />
                                                                </Grid>
                                                                <Grid style={{ padding: "5px" }}>
                                                                    <Button
                                                                        onClick={() => saveSubComment(x.id)}
                                                                        style={{
                                                                            width: '100%',
                                                                            fontSize: '10px',
                                                                            marginLeft: '-4px',
                                                                            backgroundColor: 'grey'
                                                                        }}
                                                                        variant="contained"
                                                                    >
                                                                        Incluir Observação
                                                                    </Button>
                                                                </Grid>
                                                                <Grid style={{ padding: "5px" }}>
                                                                    <Button
                                                                        onClick={() => excluirComment(x.id)}
                                                                        style={{
                                                                            width: '100%',
                                                                            fontSize: '10px',
                                                                            marginLeft: '-4px',
                                                                            backgroundColor: 'grey'
                                                                        }}
                                                                        variant="contained"
                                                                    >
                                                                        Excluir Comentário
                                                                    </Button>
                                                                </Grid>

                                                            </Grid>
                                                        )
                                                    })}
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value="3">
                                        <List>
                                            {historico && historico.length > 0
                                                ?
                                                historico.map((item, idx) => (
                                                    <ListItem
                                                        button
                                                        key={idx}
                                                        onClick={() => handleClickItem(item, idx)}
                                                        style={{
                                                            backgroundColor:
                                                                listItemSelected === idx ? '#77dd77' : 'transparent'
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={item.nome_usuario}
                                                            secondary={moment(item.criado_em).format('DD/MM/YYYY HH:mm')}
                                                        />
                                                    </ListItem>
                                                ))
                                                :
                                                null
                                            }
                                            {historico && historico.length === 0 && (
                                                <Typography variant="body2" color="textSecondary">
                                                    Nenhuma edição registrada.
                                                </Typography>
                                            )}
                                        </List>
                                    </TabPanel>


                                    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                                        <DialogTitle>Histórico de Edição</DialogTitle>
                                        <DialogContent dividers>
                                            <Typography
                                                variant="body1"
                                                style={{ whiteSpace: 'pre-wrap', marginTop: 10 }}
                                            >
                                                {htmlParaTextoSimples(selected?.texto)}
                                            </Typography>
                                        </DialogContent>
                                        <DialogActions
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: '100%'
                                            }}
                                        >
                                            <Typography sx={{ pl: 2 }} variant="subtitle2">
                                                {selected?.nome_usuario} em{' '}
                                                {moment(selected?.criado_em).format('DD/MM/YYYY [às] HH:mm')}
                                            </Typography>
                                            <Box>
                                                <Button onClick={handleResgatar}>Resgatar</Button>
                                                <Button onClick={handleClose}>Fechar</Button>
                                            </Box>
                                        </DialogActions>
                                    </Dialog>
                                </TabContext>
                            </Box>
                        </Grid>
                    }

                </Grid>
                <ConversaModal
                    idAcaoPreparatoria={props?.idNotaTecnica}
                    open={openChatIA}
                    onClose={handleCloseChatIAModal}
                    lawText={lawText}
                    summaryText={summaryText}
                />
                <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth>
                    <DialogTitle>Comentar</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <b>Trecho:</b> "{quote}"
                        </DialogContentText>
                        <Grid container style={{ alignItems: "center" }}>
                            <Grid item xs={1}>
                                <Avatar
                                    className="userAvatar"
                                    title={user.nome}
                                    src={
                                        user.url_foto
                                            ?
                                            user.url_foto
                                            :
                                            ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={11}>
                                <TextField
                                    autoFocus
                                    id="comment"
                                    placeholder='Digite algo...'
                                    type="text"
                                    value={commentary}
                                    onChange={event => setCommentary(event.target.value)}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setModalOpen(false)}>Cancelar</Button>
                        <Button onClick={() => saveComment()}>Comentar</Button>
                    </DialogActions>
                </Dialog>
            </Editor >
        </div>

    )
}

export default RealTimeQuillEditor